var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3137_1453",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3137_1453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9748 20.5C9.80814 20.5 7.92047 19.7877 6.3118 18.363C4.7038 16.9377 3.78314 15.15 3.5498 13H5.0748C5.3248 14.7333 6.0998 16.1667 7.3998 17.3C8.6998 18.4333 10.2248 19 11.9748 19C13.9248 19 15.5791 18.3207 16.9378 16.962C18.2958 15.604 18.9748 13.95 18.9748 12C18.9748 10.05 18.2958 8.39567 16.9378 7.037C15.5791 5.679 13.9248 5 11.9748 5C10.8915 5 9.8708 5.24167 8.9128 5.725C7.95414 6.20833 7.13314 6.875 6.4498 7.725H9.0498V9.225H3.9748V4.15H5.4748V6.525C6.29147 5.55833 7.26647 4.81233 8.3998 4.287C9.53314 3.76233 10.7248 3.5 11.9748 3.5C13.1581 3.5 14.2665 3.725 15.2998 4.175C16.3331 4.625 17.2331 5.23333 17.9998 6C18.7665 6.76667 19.3705 7.66267 19.8118 8.688C20.2538 9.71267 20.4748 10.8167 20.4748 12C20.4748 13.1833 20.2538 14.2873 19.8118 15.312C19.3705 16.3373 18.7665 17.2333 17.9998 18C17.2331 18.7667 16.3331 19.375 15.2998 19.825C14.2665 20.275 13.1581 20.5 11.9748 20.5ZM14.9748 16.025L11.2498 12.3V7H12.7498V11.7L16.0248 14.975L14.9748 16.025Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSettingsIcon);
export default __webpack_public_path__ + "static/media/TimeSettingsIcon.d71916d3d12359d0507c0e0cf1e827e9.svg";
export { ForwardRef as ReactComponent };